import styled from "styled-components";

export const SkillSection = styled.section`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  will-change: contents;
  z-index: 1;
  padding: 0 4rem;
  transform-style: preserve-3d;
  animation: fadeIn 1s forwards;
  animation-delay: 2.5s;
  opacity: 0;

  @media (max-width: 1020px) {
    padding-right: 2rem;
  }
  @media (max-width: 900px) {
    padding: 3rem;
    grid-gap: 3rem;
  }
  @media (max-width: 925px) {
    flex-direction: column-reverse;
  }
  @media (max-width: 500px) {
    padding: 2rem;
  }
  @media (max-width: 360px) {
    padding: 1.4rem;
  }
  @media (max-width: 300px) {
    padding-right: 0.7rem;
  }

  h1 {
    font-size: 53px;
    color: #3bcfe3;
    font-weight: 400;
    font-family: "Lato", sans-serif;
    margin-top: 0;
    position: relative;
    margin-bottom: 40px;
    left: -10px;
    @media (max-width: 745px) {
      margin-bottom: 20px;
    }
    @media (max-width: 695px) {
      margin-bottom: 20px;
    }

    span {
      color: #3bcfe3;
    }

    &:before {
      content: "<h1>";
      opacity: 0.3;
      color: #3bcfe3;
      font-size: 18px;
      font-family: "La Belle Aurore", cursive;
      position: absolute;
      margin-top: -10px;
      left: -10px;
      line-height: 18px;
    }

    &:after {
      content: "<h1/>";
      color: #3bcfe3;
      opacity: 0.3;
      font-size: 18px;
      font-family: "La Belle Aurore", cursive;
      line-height: 18px;
      position: absolute;
      left: -30px;
      bottom: -20px;
      margin-left: 20px;
    }
  }

  p {
    font-size: clamp(1rem, 2.5vw, 1.2rem);
    line-height: 26px;
    letter-spacing: 0.05rem;
    word-spacing: 0.15rem;
    color: #d6d6d6;
    width: 100%;
    font-weight: 300;
    max-width: fit-content;
  }

  .text-zone {
    width: 47%;
    vertical-align: middle;
    display: table-cell;
    max-height: 90%;

    @media (max-width: 925px) {
      max-width: 45rem;
      width: 100%;
    }

    .tech-tag,
    a {
      color: #3bcfe3;
      font-size: clamp(1rem, 2.5vw, 1.2rem);
      line-height: 26px;
      letter-spacing: 0.05rem;
      word-spacing: 0.15rem;
    }

    a {
      margin: 0 3.5px;
    }

    .tech-text {
      color: #fff;
    }
  }
  .cloud-div {
    width: 50%;

    @media (max-width: 725px) {
      max-width: 45rem;
      width: 100%;
    }
    @media (max-width: 300px) {
      margin-bottom: -2rem;
    }

    #myCanvasContainer {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      a {
        pointer-events: none;
      }
      canvas {
        @media (max-width: 1065px) {
          width: 350px;
          height: 350px;
        }
        @media (max-width: 380px) {
          width: 300px;
          height: 300px;
        }
        @media (max-width: 300px) {
          width: 250px;
          height: 250px;
        }
      }
      @media (max-width: 695px) {
        align-items: flex-end;
      }
    }

    @media (max-width: 695px) {
      width: 100%;
    }
    @media (max-width: 420px) {
      margin-top: -2rem;
    }
    @media (max-width: 390px) {
      margin-top: 0rem;
    }
    @media (max-width: 378px) {
      margin-top: -0.8rem;
    }
    @media (max-width: 362px) {
      margin-top: -1.4rem;
    }
    @media (max-width: 321px) {
      margin-top: 1.2rem;
    }
    @media (max-width: 285px) {
      margin-top: 3.7rem;
    }
  }
  @media (max-width: 695px) {
    height: 48rem;
    margin-bottom: 1.5rem;
  }
  @media (max-width: 450px) {
    height: 52rem;
  }
  @media (max-width: 420px) {
    height: 55rem;
  }
  @media (max-width: 390px) {
    height: 55rem;
  }
  @media (max-width: 380px) {
    height: 52rem;
  }
  @media (max-width: 340px) {
    height: 53rem;
  }
  @media (max-width: 300px) {
    height: 55rem;
  }
`;
